'use strict';
import { trackAction } from 'helpers/trackingOM';

export default class Search {
    constructor() {
        this.extraParams = null;
        this.classHide = 'hide';
        this.brazeCampaignParams = { screenName: 'search' };
        this.searchWrapper = document.querySelector('#search');

        if (!this.searchWrapper) return;

        this.inputBarWrapper = this.searchWrapper.querySelector('.search__inputBar');
        this.input = this.inputBarWrapper.querySelector('input');
        this.input.focus();
        this.resultsWrapper = this.searchWrapper.querySelector('.search__results');

        this.revealHandler = document.querySelectorAll('.js-search');
        this.closeHandler = this.searchWrapper.querySelector('.close');

        // START A/B TEST PLGRWEB-394 : Split Content on Search
        this.searchResultSubnav = document.getElementById('search-results-subnav');
        this.searchFiltersInView = [];
        this.activeSearchFilter = '';
        // END A/B TEST PLGRWEB-394 : Split Content on Search

        this.trendingRecommended = document.getElementById('trending-recommended');

        if (this.trendingRecommended) {
            this.trendingAnchorLinks = this.trendingRecommended
                .querySelector('.grid-view-container')
                .querySelectorAll('a');

            if (this.trendingAnchorLinks.length) {
                this.trackOnItemsClick(this.trendingAnchorLinks, 2, 'trackSearchCarouselSelect', {
                    posRowNum: 0,
                    rowHeaderTitle: 'Trending',
                    carouselModel: 'showRecommendationTrending'
                });
            }
        }
        /**
         * Delay in milliseconds
         * The delay in milliseconds between the keystroke and when a search is performed.
         * A 0 is more responsive, but can increase load on server.
         *
         * @type {number}
         */
        this.delay = 300;

        /**
         * Min required characters before search is performed
         *
         * @type {number}
         */
        this.minChars = 1;

        /**
         * Holds the keystroke timeout
         *
         * @type {string}
         */
        this.keystrokeTimer = '';

        this.inProgress = false;

        this.searchAction = null;

        //this.headerInstance = headerInstance;

        this.initialize();
        if (CBS.Registry.Features.braze_sdk === true)
            import('shared/braze_events/events').then(({ onSearchPageView }) => {
                onSearchPageView('/search', this.brazeCampaignParams);
            });
    }

    setExtraParams(obj){
        this.extraParams = obj;
      }

    /**
     * Initialize search component
     * - add event listeners to reveal and hide search ui
     */
    initialize() {
        this.closeHandler.addEventListener('click', (e) => {
            e.preventDefault();
            this.trackEvent('trackSearchCancel', {
                searchEventCancel: '1',
                PageType: 'search',
                searchTerm: this.input.value
            });
            this.reset();
        });

        this.keystrokeHandler();
    }

    /**
     * Reveal search UI
     */
    reveal() {}

    trackSearch(trackName, vars) {
        let screen_vars = {
            pageType: 'search',
            screenName: '/search/',
            searchTerm: this.input.value,
            searchEventStart: null
        };

        Object.assign(screen_vars, vars);

        //trigger the tracking beacon
        trackAction(trackName, screen_vars);
    }

    /**
     * Reset search elements
     * - clean up input box
     * - clean up results
     * - hide search UI
     */
    reset() {
        //window.history.pushState('', '', pageUrl);

        if (document.referrer.includes('cbs.com')) {
            window.history.go(-1);
        } else {
            window.location.href = '/';
        }

        return false;
    }

    /**
     * Reset results wrapper only
     *
     */
    resetResultsWrapper() {
        this.resultsWrapper.innerHTML = '';
        // START A/B TEST PLGRWEB-394 : Split Content on Search
        this.inputBarWrapper.classList.remove('with-filters');
        this.searchFiltersInView = [];
        this.activeSearchFilter = '';
        // END A/B TEST PLGRWEB-394 : Split Content on Search
    }

    /**
     * Trigger window resize event to fix carousel rendering issues
     *
     */
    refreshUI() {
        window.dispatchEvent(new Event('resize'));
    }

    /**
     * Reset search input field
     *
     */
    resetInputField() {
        this.input.value = '';
    }

    /**
     * Event handler for keystroke within search input field
     *
     */
    keystrokeHandler() {
        this.input.addEventListener(
            'keyup',
            this.debounce((e) => {
                //key code handler
                let keyState = this.keyCodeHandler(e);
                
                if (keyState === false) {
                    return;
                }

                this.checkInput();
            }, 500)
        );
        // submit with Enter button
        this.input.addEventListener(
            'keypress', 
            this.debounce((e) => {
                if(e.key === 'Enter') {
                    this.checkInput();
                }
            }, 500)
        );
    }

    checkInput() {
        // get input field value
        let inputValue = this.input.value.trim();
        
        //  if white spaces, clear input box so that placeholder text is displayed again
        if (inputValue.length === 0) {
            this.input.value = '';
            this.hideCarousels(false);
            this.resetResultsWrapper();
            this.refreshUI();
            this.trackSearch('trackSearchCancel', {
                searchEventCancel: '1'
            });
        }

        //reset ajax search
        if (this.searchAction) {
            this.inProgress = false;
            this.searchAction.abort();
        }
        
        // check length
        if (inputValue.length >= this.minChars && this.inProgress === false) {
            this.performSearch(inputValue);
        }
    }

    debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this,
                args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    /**
     * Handler for special keys
     * Skip execution for selected keys
     *
     * @desc For reference: https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
     * @param evt
     */
    keyCodeHandler(evt) {
        // esc key
        if (evt.keyCode === 27) {
            this.reset();
        }

        if (evt.keyCode > 8 && evt.keyCode < 46) {
            return false;
        }

        if (evt.keyCode > 90 && evt.keyCode < 96) {
            return false;
        }
    }

    /**
     * Send query to fetch matching results
     *
     * @param inputValue
     */
    performSearch(inputValue) {
        this.inProgress = true;

        let searchObj = {
            term: inputValue.url_encode(),
            ...this.extraParams
        };

        this.searchAction = $.ajax({
            type: 'GET',
            url: CBS.Registry.region.prefix + '/search/lookup/',
            data: searchObj,
            dataType: 'json',
            success: (resp) => {
                this.displayResults(resp);
            }
        });

        this.searchAction.done(() => {
            this.inProgress = false;
        });
    }

    hideCarousels(hide) {
        if (hide) {
            $('.js-le-carousel').fadeOut(0);
        } else {
            $('.js-le-carousel').fadeIn();
        }
    }

    /**
     * Display search results UI
     *
     */
    displayResults(resp) {
        this.resultsWrapper.innerHTML = resp.html;

        let items2 = this.resultsWrapper.querySelectorAll('a[aa-link]');
        let noResults = this.resultsWrapper.querySelectorAll('.search__results--empty');

        let trackSearchListingData = {
            pageType: 'search',
            screenName: '/search/',
            searchTerm: this.input.value,
        };
        
        if (noResults.length) {
            // START A/B TEST PLGRWEB-394 : Split Content on Search
            this.inputBarWrapper.classList.remove('with-filters');
            // END A/B TEST PLGRWEB-394 : Split Content on Search
            
            this.hideCarousels(false);
            trackSearchListingData.searchEventNoResult = '1';
            this.trackEvent('trackNoSearchResults', trackSearchListingData);
            
        } else {
            this.hideCarousels(true);
         
            // START A/B TEST PLGRWEB-394 : Split Content on Search
            if (this.searchResultSubnav) {
                this.initializeContentFilters();
                trackSearchListingData.searchFilterInView = this.searchFiltersInView;
            } else {
                this.removeResultSubnav();
            }
            // END A/B TEST PLGRWEB-394 : Split Content on Search

            //call tracking when do a search

            let onNowElements = this.resultsWrapper.querySelectorAll('.search__results--live-results a');
            onNowElements = [].slice.call(onNowElements);

            let onNowSearchCount = onNowElements.filter(function(el) {
                return getComputedStyle(el).display !== "none"
            }).length.toString();

            let resultsSearchCount = this.resultsWrapper.querySelectorAll('.search__results--results a').length.toString();

            this.trackEvent('trackSearchResultListing', {
                searchResultListing: '1',
                pageType: 'search',
                screenName: '/search/',
                searchTerm: this.input.value,
                onNowSearchCount,
                resultsSearchCount
            });
        }

        if (CBS.Registry.lazyImage !== undefined) {
            CBS.Registry.lazyImage.revalidate();
        }
        
        setTimeout(() => {
            for (let i = 0; i < items2.length; i++) {
                let o = items2[i];
                let aaLinkValues = $(o).attr('aa-link').split('|');

                let title = aaLinkValues[4];
                let showId = aaLinkValues[5];
                let movieId = aaLinkValues[6];
                let contentLocked = aaLinkValues[23];
                let liveTvChannel = aaLinkValues[24];
                let stationCode = aaLinkValues[25];
                let itemParams = {};

                if(liveTvChannel && stationCode){
                    itemParams.showSeriesTitle = title;
                } else if (showId) {
                    itemParams.showSeriesId = showId;
                    itemParams.showSeriesTitle = title;
                } else {
                    itemParams.movieId = movieId;
                    itemParams.movieTitle = title;
                }

                itemParams.contentLocked = contentLocked;
                itemParams.liveTvChannel = liveTvChannel;
                itemParams.stationCode = stationCode;
                
                let trackSearchResultData = {
                    searchEventComplete: '1',
                    PageType: 'search',
                    searchTerm: this.input.value,
                    ...itemParams
                };

                // call tracking when user clicks a search result item
                o.addEventListener('click', (e) => {


                    let parent = e.target.closest(".search__results--display");
                    let prevSibling = parent.previousElementSibling;
                    let menuItemLabel = prevSibling.innerText.trim();


                    let obj = {
                        searchEventComplete: '1',
                        PageType: 'search',
                        searchTerm: this.input.value,
                        menuItemLabel,
                        ...itemParams
                    };

                    


                    // START A/B TEST PLGRWEB-394 : Split Content on Search
                    if (this.searchResultSubnav) {
                        obj.menuItemLabel = this.activeSearchFilter;
                        obj.searchFilterInView = this.searchFiltersInView;
                    }
                    // END A/B TEST PLGRWEB-394 : Split Content on Search


                    obj = Object.fromEntries(Object.entries(obj).filter(([key, value]) => value !== ""));




                    this.trackEvent('trackSearchResult', obj);
                });

                let img = o.querySelector('img');
                if (img) {
                    img.classList.add('reveal');
                }
            }

            const items = this.resultsWrapper.querySelectorAll('img');

            if (this.trendingRecommended) {
                if (items > 0) {
                    this.trendingRecommended.classList.add(this.classHide);
                } else {
                    this.trendingRecommended.classList.remove(this.classHide);
                }
            }

            // this.trackOnItemsClick(items, 1, "trackSearchResult", {
            //   searchEventComplete: "1",
            // });
        }, 300);
    }

    trackEvent(event, data) {
        try {
            om.trackAction(event, data);
        } catch (e) {}
    }

    trackOnItemsClick(resp, index, trackType = 'trackSearchResult', vars = {}) {
        const self = this;

        for (let i = 0; i < resp.length; i++) {
            const item = resp[i];
            item.classList.add('reveal');
            item.addEventListener('click', (e) => {
                const parts = e.path[index].getAttribute('aa-link').split('|');

                if (item.href) {
                    vars.carouselLink = item.href;
                }
                if (parts) {
                    vars.posColNum = parseInt(parts[3]);
                    const obj =
                        !parts[10] || parts[10] !== 'movies'
                            ? {
                                  ...vars,
                                  showSeriesId: parts[9],
                                  showSeriesTitle: parts[4],
                                  carouselContentType: 'show'
                              }
                            : {
                                  ...vars,
                                  movieId: parts[9],
                                  movieTitle: parts[4],
                                  carouselContentType: 'movie'
                              };

                    self.trackSearch(trackType, obj);
                }
            });
        }
    }

    /**
     * START A/B TEST PLGRWEB-394 : Split Content on Search
     * Method to initialize event listeners for filtering results by content type
     */
    initializeContentFilters() {
        const searchResultFilters = document.querySelector('.result-filters');
        const resultsCopy = document.querySelector('.results-text-copy');
        
        // Reset search filters in view
        this.searchFiltersInView = [];
        
        // Hide default search result copy
        if (resultsCopy) resultsCopy.hidden = true;
        // Display search result subnav for filtering content
        if (searchResultFilters) searchResultFilters.classList.remove(this.classHide);
        this.inputBarWrapper.classList.add('with-filters');
        
        // Get result filter links to init event listeners
        const filterResultsByAll = document.querySelector('.all-result-filter');
        const filterResultsByShows = document.querySelector('.shows-result-filter');
        const filterResultsByMovies = document.querySelector('.movies-result-filter');

        // Show all search results
        if (filterResultsByAll) {
            filterResultsByAll.addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelector('.active').classList.remove('active');
                // Set "All" filter as active menu item
                filterResultsByAll.classList.add('active');
                this.activeSearchFilter = 'All';
                this.filterSearchResults('all');
            });
            // Add all filter in view for tracking
            this.searchFiltersInView.push('All');
            // 'All' is the active search filter by default
            this.activeSearchFilter = 'All';
        }

        // Filter search results by shows only
        if (filterResultsByShows) {
            filterResultsByShows.addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelector('.active').classList.remove('active');
                // Set "Shows" filter as active menu item
                filterResultsByShows.classList.add('active');
                this.activeSearchFilter = 'Shows';
                this.filterSearchResults('show');
            });
            // Add shows filter in view for tracking
            this.searchFiltersInView.push('Shows');
        }

        // Filter search results by movies only
        if (filterResultsByMovies) {
            filterResultsByMovies.addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelector('.active').classList.remove('active');
                // Set "Movies" filter as active menu item
                filterResultsByMovies.classList.add('active');
                // Set "Movies" filter as active menu item
                this.activeSearchFilter = 'Movies';
                this.filterSearchResults('movie');
            });
            // Add movies filter in view for tracking
            this.searchFiltersInView.push('Movies');
        }
    }

    /**
     * Method to display search results that match the current filter type
     * @param type
     */
    filterSearchResults(type) {
        // Get all search result items
        const items = this.resultsWrapper.querySelectorAll('a[aa-link]');
        // Only display results that match the filter type
        for (let i = 0; i < items.length; i++) {
            let o = items[i];
            if (o.classList.contains(type) || type === 'all') {
                o.style.display = '';
            } else {
                o.style.display = 'none';
            }
        }
        // Add track event from user clicking on a search filter
        this.trackEvent('trackSearchFilterSelect', {
            PageType: 'search',
            menuItemLabel: this.activeSearchFilter,
            searchTerm: this.input.value
        });
    }

    /**
     * Method to remove search results secondary nav bar from page
     */
    removeResultSubnav() {
        const searchResultFilters = document.querySelector('.result-filters');
        if (searchResultFilters) searchResultFilters.remove();
    }
    /**
     * END A/B TEST PLGRWEB-394 : Split Content on Search
     */
    
}
